




































import { defineComponent, reactive, toRefs, SetupContext } from '@vue/composition-api';
import { urlExt } from 'kd-lib/packages/url';
import Generate from '@/utils/generate';
import Banner from './components/Banner.vue';
import Content from './components/Content.vue';
import BottomFixed from './components/BottomFixed.vue';
import MathContent from '../produceResult/components/MathContent/index.vue';
import { InvokeApp } from '@kd/invokeapp';
import { Toast } from 'nut';

// TODO 打点
export default defineComponent({
  name: 'Index',
  components: {
    Banner,
    Content,
    BottomFixed,
    MathContent
  },
  setup(_props, { root }: SetupContext) {
    const pageId = decodeURIComponent(urlExt.getQuery('pageId')) || '';
    const cuid = decodeURIComponent(urlExt.getQuery('cuid')) || '';
    const data = reactive({
      questionData: {
        content: '',
        picList: []
      },
      answerData: {
        content: '',
        picList: []
      }
    });

    // 获取页面数据
    const getPageData = async () => {
      try {
        const params = { pageId, cuid };
        const g = new Generate(params);
        const res = await root.$http.post(root.api.questionsharelandingpage, {
          fkey: g['fkey'],
          ftime: g['ftime'],
          ...params
        });
        if (res?.data) {
          data.questionData = res.data.questionData;
          data.answerData = res.data.answerData;
        }
      } catch (err) {
        Toast(err.str || '网络繁忙，请重试');
      }
    };

    getPageData();

    const downloadKd = () => {
      const nativeLink = 'kwzy://com.kuaiduizuoye.scan/main/invite/activity';
      let DOWNLOADLINK = `https://www.kuaiduizuoye.com/codesearch/download/apk?name=com_kuaiduizuoye_scan&channel=10003e3`;
      const UNIVERSALLINK = 'https://oia.kuaiduizuoye.com/kdactivitymain/universalLink.html?page=showhomepage';

      const invoker = new InvokeApp({
        nativeLinkAndroid: nativeLink,
        downloadLink: DOWNLOADLINK,
        nativeLinkIos: nativeLink,
        universalLink: UNIVERSALLINK
      });

      invoker.active();
    };

    return {
      ...toRefs(data),
      data,
      downloadKd
    };
  }
});
